/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyUserGroup,
    ReadOnlyUserGroupFromJSON,
    ReadOnlyUserGroupFromJSONTyped,
    ReadOnlyUserGroupToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20041
 */
export interface InlineResponse20041 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20041
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20041
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20041
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyUserGroup>}
     * @memberof InlineResponse20041
     */
    results: Array<ReadOnlyUserGroup>;
}

export function InlineResponse20041FromJSON(json: any): InlineResponse20041 {
    return InlineResponse20041FromJSONTyped(json, false);
}

export function InlineResponse20041FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20041 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyUserGroupFromJSON)),
    };
}

export function InlineResponse20041ToJSON(value?: InlineResponse20041 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyUserGroupToJSON)),
    };
}


